<template lang="pug">
#v-app
  v-header
  #about: v-about
  #topics: v-topics
  #review: v-review
  v-footer
</template>

<script>
import { parse } from 'query-string'
import VHeader from '@/components/Header.vue'
import VAbout from '@/components/About.vue'
import VTopics from '@/components/Topics.vue'
import VReview from '@/components/Review.vue'
import VFooter from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    VHeader,
    VAbout,
    VTopics,
    VReview,
    VFooter,
  },
  created() {
    document.cookie = `XSRF-TOKEN=${Math.random().toString(36).substr(2)}`
    this.$store.commit('saveUtm', parse(location.search))
    $(window).resize(() => {
      const mobile = $(window).width() < 1024
      if(this.$store.state.mobile !== mobile) {
        if(mobile) {
          this.$store.commit('setMobile', true)
          this.$store.commit('setScrollOffset', 0)
        } else {
          this.$store.commit('setMobile', false)
          this.$store.commit('setScrollOffset', 70)
        }
      }
    }).resize()
  },
  mounted() {
    $(window).scroll(() => {
      const scrollTop = $(window).scrollTop() + this.$store.state.scroll.offset
      const sections = this.$store.state.scroll.sections
      for(let i = sections.length - 1; i >= 0; i--) {
        if(scrollTop >= $(sections[i]).position().top) {
          if(this.$store.state.scroll.position !== sections[i]) {
            this.$store.commit('setScrollPosition', sections[i])
            history.replaceState(null, null, sections[i])
          }
          break
        }
      }
    }).scroll()
  },
}
</script>

<style lang="sass" scoped>
@import "~@/mixin.sass"

#v-app
  overflow-x: hidden
  padding-top: 70px

@media (max-width: 1023px)
  #v-app
    padding-top: 0
</style>
